export const palletTypeOptions = [
  { label: "Small Pallet", value: "SMALL" },
  { label: "Standard Pallet", value: "STANDARD" },
  { label: "Large Pallet", value: "LARGE" },
];

export const poTypeOptions = [
  {
    label: "Standard",
    value: "S",
  },
  {
    label: "Blanket",
    value: "B",
  },
];

export const countryOptions = ["Malaysia", "Singapore"];
export const orderTypeOptions = ["B2B", "B2C","WhseTransfer","Crossdock","Reserve","Scrap","Return To Owner"];
export const shipmentTypeOptions = ["Integrated", "NonIntegrated", "SelfCollect"];
export const stateOptions = [
  "Kuala Lumpur",
  "Selangor",
  "Pulau Pinang",
  "Perak",
  "Kedah",
  "Sarawak",
  "Singapore",
];

export const transportAgmtOptions = ["CUSTOMER", "WAREHOUSE"];

export const truckTypeOptions = [
  "1 TON",
  "3 TON",
  "5 TON",
  "VAN",
  "20FT",
  "40FT",
  "LCL (Carton)",
  "LCL (Palletised)",
];

export const manPowerRateOptions = [
  "Weekend office hour 1.0",
  "Weekdays office hour 1.0",
  "Weekend after office hour 1.0",
  "Weekdays after office hour 1.0",
  "Weekend office hour 1.5",
  "Weekdays office hour 1.5",
  "Weekend after office hour 1.5",
  "Weekdays after office hour 1.5",
];

export const customerTypeOptions = ["Principle", "eCommerce"];
export const currencyCodeOptions = ["MYR", "SGD"];
export const defaultOrderTypeOptions = [
  "B2B",
  "B2C",
  "Crossdock",
  // "Reserve",
  // "WhseTransfer",
  // "Scrap",
  // "Return To Owner",
];

export const defaultPickingTypeOptions = [
  "ZIGZAG",
];

export const conditionOptions=["NORMAL","DAMAGE"]

export const holdPalletOptions=[
  {label: "All pallet", value:"A"}, 
  {label: "Pallet with hold stock", value:"H"}, 
  {label: "Pallet with no hold stock", value:"N"}, 
]
